import { CHAT_FUNCTIONS } from '../../../config/chatFunctionNames';

/**
 * Check if a message is a cancel booking response.
 * Detection is purely by function_name — no text pattern matching.
 */
export function isCancelBookingMessage(message) {
  return message?.function_name === CHAT_FUNCTIONS.CANCEL_BOOKING;
}

/**
 * Extract cancel booking data from a message.
 * Returns { bookings, cancelHeader, selectionPrompt } or null.
 *
 * @returns {{ bookings: Array, cancelHeader: string, selectionPrompt: string }|null}
 */
export function getCancelBookingData(message) {
  if (!isCancelBookingMessage(message)) return null;

  const bookings = message.raw_output?.bookings;
  if (!Array.isArray(bookings) || bookings.length === 0) return null;

  return {
    bookings,
    cancelHeader: message.raw_output?.cancel_header || '',
    selectionPrompt: message.raw_output?.selection_prompt || '',
  };
}

/**
 * Extract header text before the numbered booking list.
 * e.g. "Here are your active bookings:" from full content.
 * Uses same regex pattern as organization events / booking list.
 */
export function getCancelBookingHeader(content) {
  if (!content) return content;
  const parts = content.split(/\n\n\d+\.\s/);
  return parts[0].trim();
}
